export default "__VITE_ASSET__gwVqThSJ__"